import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const INIT = `${SCOPE}/INIT`;

export const UPDATE = `${SCOPE}/UPDATE`;
export const SET_SELECTED_METRICS = `${SCOPE}/SET_SELECTED_METRICS`;
export const SET_SELECTED_DIMENSION = `${SCOPE}/SET_SELECTED_DIMENSION`;
export const SET_SELECTED_FILTERS = `${SCOPE}/SET_SELECTED_FILTERS`;
export const SET_APPLIED_SORT = `${SCOPE}/SET_APPLIED_SORT`;
export const SET_SELECTED_INTERVAL = `${SCOPE}/SET_SELECTED_INTERVAL`;
export const REMOVE_APPLIED_FILTER = `${SCOPE}/REMOVE_APPLIED_FILTER`;
export const SET_DEFAULT_FILTER_INTERVAL = `${SCOPE}/SET_DEFAULT_FILTER_INTERVAL`;
export const SET_SELECTED_GRANULARITY = `${SCOPE}/SET_SELECTED_GRANULARITY`;
export const SET_TIMESERIES_MODE = `${SCOPE}/SET_TIMESERIES_MODE`;
export const SET_UNIT_MODE = `${SCOPE}/SET_UNIT_MODE`;
export const SET_SELECTED_SHORTCUT = `${SCOPE}/SET_SELECTED_SHORTCUT`;
export const SET_LIVE_MODE = `${SCOPE}/SET_LIVE_MODE`;
export const PERSIST_STATE = `${SCOPE}/PERSIST_STATE`;
export const UPDATE_PERSISTED_ML_STATE = `${SCOPE}/UPDATE_PERSISTED_ML_STATE`;
export const SET_APPLIED_SEARCH = `${SCOPE}/SET_APPLIED_SEARCH`;
